import { render, staticRenderFns } from "./CurrencyDigitsPage.vue?vue&type=template&id=1fe08760&scoped=true&"
import script from "./CurrencyDigitsPage.vue?vue&type=script&lang=ts&"
export * from "./CurrencyDigitsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyDigitsPage.vue?vue&type=style&index=0&id=1fe08760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe08760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VRow,VSelect,VSimpleTable})
